/*
 * @Author: LCQ
 * @Date: 2024-07-02 15:09:51
 * @LastEditTime: 2024-07-04 19:21:57
 * @LastEditors: LCQ
 * @Description: 锁车管理 新的 路由
 * @FilePath: \operation.dstcar.com\src\router\lockCarNew\index.js
 */
const lockCarNew = () => import('@/pages/lockCarNew/list/index.vue')
const fullRemoveLock = () => import('@/pages/lockCarNew/fullRemoveLock/index.vue')
const removeLock = () => import('@/pages/lockCarNew/removeLock/index.vue')
const temporaryRemoveLock = () => import('@/pages/lockCarNew/temporaryRemoveLock/index.vue')
const resultAnalysis = () => import('@/pages/lockCarNew/resultAnalysis/index.vue')
export default [
  {
    path: '/lockCarNew',
    name: 'lockCarNew',
    component: lockCarNew,
    meta: {
      storeKey: 'oss:aftersales:app:lock'
    }
  },
  {
    path: '/lockCarNew/fullRemoveLock',
    name: 'FullRemoveLock',
    component: fullRemoveLock,
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/lockCarNew/removeLock',
    name: 'RemoveLock',
    component: removeLock,
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/lockCarNew/temporaryRemoveLock',
    name: 'TemporaryRemoveLock',
    component: temporaryRemoveLock,
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/lockCarNew/resultAnalysis',
    name: 'ResultAnalysis',
    component: resultAnalysis,
    meta: {
      storeKey: '*'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/lockCarNew/index.js